export default __webpack_public_path__ + "static/media/AGC_2025_R2_QP_Class_4.4fc0b81e.pdf";